import React, { useState } from 'react';

export default function Report() {
  const [fields, setFields] = useState({
    orderNumber: '',
    propertyName: '',
    inspectionDate: '',
    physicalAddress: '',
    propertySuburb: '',
    propertyState: '',
    propertyPostcode: '',
    ctsSpNumber: '',
    dateOfReport: '',
    bodyCorporate: '',
    propertyInspectionDate: '',
    satisfiesRequirements: '',
    buildingType: '',
    yearOfConstruction: '',
    financialYearStart: '',
    openingBalance: '',
    numberOfLots: '',
    numberOfEntitlements: '',
    proposedLevyPerLot: '',
    proposedLevyAnnual: '',
    companyTaxRate: '',
    buildingCostEscalation: '',
    contingencyAllowance: '',
    registeredForGst: 'yes',
    forecastPeriod: '',
    asbestosSurvey: '',
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    setFields({ ...fields, [e.target.name]: e.target.value });
  };

  return (
    <div style={{ maxWidth: 900, margin: '0 auto', background: '#fff', padding: 24, maxHeight: '100vh', overflowY: 'auto', paddingBottom: 80 }}>
      <h2 style={{ textAlign: 'center', color: '#3cb0c7', fontWeight: 600, letterSpacing: 1 }}>SINKING FUND FORECAST</h2>
      {/* ORDER DETAILS 1 */}
      <Section title="ORDER DETAILS">
        <Row>
          <Field label="Order Number" name="orderNumber" value={fields.orderNumber} onChange={handleChange} />
          <Field label="Property Name" name="propertyName" value={fields.propertyName} onChange={handleChange} />
          <Field label="Inspection Date" name="inspectionDate" value={fields.inspectionDate} onChange={handleChange} type="date" />
        </Row>
      </Section>
      {/* ORDER DETAILS 2 */}
      <Section title="ORDER DETAILS">
        <Row>
          <Field label="Physical Address:" name="physicalAddress" value={fields.physicalAddress} onChange={handleChange} />
          <Field label="Property Suburb:" name="propertySuburb" value={fields.propertySuburb} onChange={handleChange} />
          <Field label="Property State:" name="propertyState" value={fields.propertyState} onChange={handleChange} />
          <Field label="Property Postcode:" name="propertyPostcode" value={fields.propertyPostcode} onChange={handleChange} />
        </Row>
        <Row>
          <Field label="Property Name:" name="propertyName" value={fields.propertyName} onChange={handleChange} />
          <Field label="CTS/SP Number:" name="ctsSpNumber" value={fields.ctsSpNumber} onChange={handleChange} />
          <Field label="Date Of Report:" name="dateOfReport" value={fields.dateOfReport} onChange={handleChange} type="date" />
        </Row>
      </Section>
      {/* SECTION 1 - SUMMARY OF SINKING FUND FORECAST */}
      <Section title="SECTION 1 - SUMMARY OF SINKING FUND FORECAST">
        <Row>
          <Field label="Body Corporate/ Owners Corp." name="bodyCorporate" value={fields.bodyCorporate} onChange={handleChange} />
          <Field label="Property Inspection Date:" name="propertyInspectionDate" value={fields.propertyInspectionDate} onChange={handleChange} type="date" />
        </Row>
        <Row>
          <Field label="This forecast satisfies the requirements of the:" name="satisfiesRequirements" value={fields.satisfiesRequirements} onChange={handleChange} />
        </Row>
      </Section>
      {/* REPORT SUMMARY */}
      <Section title="REPORT SUMMARY">
        <Row>
          <Field label="Building Type:" name="buildingType" value={fields.buildingType} onChange={handleChange} type="select" options={["BFP"]} />
          <Field label="Year of Construction/ Registration Date:" name="yearOfConstruction" value={fields.yearOfConstruction} onChange={handleChange} />
        </Row>
        <Row>
          <Field label="Financial Year Start Date:" name="financialYearStart" value={fields.financialYearStart} onChange={handleChange} type="date" />
          <Field label="Opening Balance:" name="openingBalance" value={fields.openingBalance} onChange={handleChange} prefix="$" />
        </Row>
        <Row>
          <Field label="Number of Lots:" name="numberOfLots" value={fields.numberOfLots} onChange={handleChange} />
          <Field label="Number of Entitlements:" name="numberOfEntitlements" value={fields.numberOfEntitlements} onChange={handleChange} />
        </Row>
        <Row>
          <Field label="Proposed Sinking Fund Levy - Per Lot Entitlement:" name="proposedLevyPerLot" value={fields.proposedLevyPerLot} onChange={handleChange} prefix="$" />
          <Field label="Proposed Sinking Fund Levy - Annual:" name="proposedLevyAnnual" value={fields.proposedLevyAnnual} onChange={handleChange} prefix="$" />
        </Row>
      </Section>
      {/* ADDITIONAL INFORMATION */}
      <Section title="ADDITIONAL INFORMATION">
        <Row>
          <Field label="Company Taxation Rate:" name="companyTaxRate" value={fields.companyTaxRate} onChange={handleChange} />
          <Field label="Allowance for Future Building Cost Escalation:" name="buildingCostEscalation" value={fields.buildingCostEscalation} onChange={handleChange} />
          <Field label="Contingency Allowance:" name="contingencyAllowance" value={fields.contingencyAllowance} onChange={handleChange} />
        </Row>
        <Row>
          <Field label="Registered for GST:" name="registeredForGst" value={fields.registeredForGst} onChange={handleChange} type="select" options={["yes", "no"]} />
          <Field label="Forecast Period - Number of Years:" name="forecastPeriod" value={fields.forecastPeriod} onChange={handleChange} />
        </Row>
        <Row>
          <Field label="Asbestos Survey:" name="asbestosSurvey" value={fields.asbestosSurvey} onChange={handleChange} type="select" options={["is not applicable", "is applicable"]} />
        </Row>
      </Section>
      {/* GOODS AND SERVICES TAX (GST) */}
      <Section title="GOODS AND SERVICES TAX (GST)">
        <div style={{ padding: 8, fontSize: 14 }}>
          The forecast is exclusive of the ten (10%) allowance for Goods and Services Tax.
        </div>
      </Section>
    </div>
  );
}

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div style={{ margin: '32px 0 0 0' }}>
      <div style={{ background: '#f3f3f3', color: '#3cb0c7', fontWeight: 600, padding: '8px 12px', fontSize: 16, letterSpacing: 1 }}>{title}</div>
      <div style={{ padding: 16 }}>{children}</div>
    </div>
  );
}

function Row({ children }: { children: React.ReactNode }) {
  return <div style={{ display: 'flex', gap: 24, marginBottom: 16, flexWrap: 'wrap' }}>{children}</div>;
}

function Field({ label, name, value, onChange, type = 'text', prefix, options }:
  { label: string, name: string, value: string, onChange: any, type?: string, prefix?: string, options?: string[] }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', flex: 1, minWidth: 220 }}>
      <label style={{ fontSize: 13, marginBottom: 4 }}>{label}</label>
      {type === 'select' ? (
        <select name={name} value={value} onChange={onChange} style={{ padding: 6, fontSize: 15 }}>
          {options?.map(opt => <option key={opt} value={opt}>{opt}</option>)}
        </select>
      ) : (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {prefix && <span style={{ marginRight: 4 }}>{prefix}</span>}
          <input
            name={name}
            value={value}
            onChange={onChange}
            type={type}
            style={{ flex: 1, padding: 6, fontSize: 15 }}
          />
        </div>
      )}
    </div>
  );
} 